import { render, staticRenderFns } from "./DocumentTree.vue?vue&type=template&id=58158ce9&"
import script from "./DocumentTree.vue?vue&type=script&lang=ts&"
export * from "./DocumentTree.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTree.vue?vue&type=style&index=0&id=58158ce9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VIcon,VTreeview})
